<div>
    <button class="btn btn-primary"
            (click)="createCargo()"
    >
        Создать груз
    </button>

    @if (checkedAccordion.includes(true)) {
        <button class="btn btn-primary"
                (click)="addCargosToTransaction()"
        >
            Добавить груз в транзакцию
        </button>
    }
</div>
<mat-accordion
        [displayMode]="'flat'"
        [multi]="true"
>
    @for (cargo of allCargos; track cargo.ps_cargo_key; let i = $index) {
        <mat-expansion-panel class="w-50">
            <mat-expansion-panel-header
                    [collapsedHeight]="'48px'"
                    [expandedHeight]="'48px'"
            >
                <mat-panel-title>
                    <mat-checkbox
                            [checked]="checkedAccordion[i]"
                            (click)="$event.stopPropagation()"
                            (change)="checkAccordion(i, $event.checked)"
                    ></mat-checkbox>
                    {{ cargo.ps_cargo_key }}

                    <mat-chip class="ms-2">
                        {{ cargo.cargo_status }}
                    </mat-chip>
                    <mat-chip class="ms-2">
                        {{ cargo.created_at | date:'HH:mm dd.MM.yyyy' }}
                    </mat-chip>
                    <mat-chip class="ms-2">
                        <strong>Партии: </strong> {{ cargo.product_parties.length }}
                    </mat-chip>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div>
                @for (party of cargo.product_parties; track $index; let isFirst = $first) {
                    @if (!$first) {
                        <mat-divider></mat-divider>
                    }
                    <h2 [class.mt-3]="!isFirst">Партия #{{ $index + 1 }}</h2>
                    <strong>"cargo_key":</strong> {{ party.cargo_key }}<br>
                    <strong>"created_at":</strong> {{ party.created_at | date:'HH:mm dd.MM.yyyy' }} <br>
                    <strong>"product_count":</strong> {{ party.product_count }}<br>
                    <strong>"product_count_type":</strong> {{ party.product_count_type }}<br>
                    <strong>"product_puid":</strong> {{ party.product_puid }}<br>
                    <strong>"ps_party_key":</strong> {{ party.ps_party_key }}
                }
            </div>
        </mat-expansion-panel>
    }
</mat-accordion>
